module.exports = __webpack_public_path__ + "img/loto-4-59.da3d2dd2.png";